/* eslint-disable react/no-array-index-key */
import React from 'react'
import Experience from './experience'
import experiences from './data/experienceData'
import './index.scss'

const Timeline = () => (
  <>
    <h3 style={{ textAlign: 'center' }}>Experience</h3>
    {experiences.length > 0 && (
      <div className="timeline-container">
        {experiences.map((data, idx) => (
          <Experience experience={data} key={idx} />
        ))}
      </div>
    )}
  </>
)

export default Timeline
